'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import VerifyWithPasskeyModal from '@flipster/features/src/passkey/VerifyWithPasskeyModal';
import { zendesk } from '@flipster/features/src/shared/zendesk/url';

import { passkeyLoginFlowBunja } from './bunja';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const PasskeyLoginFlow = ({ isOpen, onClose }: Props) => {
  const { loginStepAtom, loginWithPasskey } = useBunja(passkeyLoginFlowBunja);
  const loginStep = useAtomValue(loginStepAtom);

  const handleClose = () => {
    onClose();
  };

  return (
    <VerifyWithPasskeyModal
      isOpen={isOpen}
      verifyStep={loginStep}
      onClickUnvailableButton={() => {
        window.open(zendesk.getUrl('RequestNew'), '_blank', 'noopener');
      }}
      onClickTryAgainButton={loginWithPasskey}
      onClose={handleClose}
    />
  );
};

export default PasskeyLoginFlow;
